class BasePolygonPlot {
    constructor() {
        this.x = [];
        this.y = [];
    }

    extractPolygonFromLine(pointStart, pointEnd, height, compareGeometry) {
        let xEnd = [pointEnd[0], pointEnd[0]]
        let yEnd = [pointEnd[1] + height, pointEnd[1]]
        this.x = [pointStart[0], pointStart[0]]
        this.y = [pointStart[1], pointStart[1] + height]

        let inbetweenPoints = compareGeometry.filter(item => item[0] >= pointStart[0] && item[0] <= pointEnd[0])
        inbetweenPoints.forEach(item => {
            this.x.push(item[0])
            this.y.push(item[1] + height)
        })
        let clonedPoints = JSON.parse(JSON.stringify(inbetweenPoints))

        let reversedInbetweenPoints = structuredClone(clonedPoints)?.reverse()
        this.x.push(...xEnd)
        this.y.push(...yEnd)
        reversedInbetweenPoints.forEach(item => {
            this.x.push(item[0])
            this.y.push(item[1])
        })
        this.x.push(pointStart[0])
        this.y.push(pointStart[1])
    }
}

export class LoadAreaPlot extends BasePolygonPlot {
    constructor(item, name = "", fill = 'toself', color = 'blue') {
        super();
        this.id = item.id
        this.item = item;
        this.fill = fill;
        this.name = this.hovertext = name + item.label
        this.hoverinfo = 'text'
        this.mode = 'lines+text+markers';
        this.type = 'scatter';
        this.line = {
            color: color,
            width: 1,
        }
        this.marker = {
            color: 'rgb(255,255,255)',
            size: 5,
            line: {
                color: 'rgb(0,0,0)',
                width: 1
            }
        }
    }
}

export class LoadSpreadPlot {
    constructor(item, reverse = false) {
        this.reverse = reverse
        this.id = item.id
        this.item = item;
        this.mode = 'lines+text+markers';
        this.type = 'scatter';
        this.showlegend = false;
        this.line = {
            dash: 'dot',
            color: 'black',
            width: 2,
        }
        this.hovertext = item.label + '_spread'
        this.hoverinfo = 'text'
        this.marker = {
            color: 'rgb(255,255,255)',
            size: 5,
            line: {
                color: 'rgb(0,0,0)',
                width: 1
            }
        }
    }

    create(point, angle, length) {
        let coordinate = this.rotatePoint(point[0], point[1], length, angle)
        this.x = [point[0], coordinate[0]]
        this.y = [point[1], coordinate[1]]
    }

    rotatePoint(cx, cy, radius, angleInDegrees) {
        let x = cx + radius
        let y = cy + radius
        let angle = -(angleInDegrees) * (Math.PI / 180);
        let translationX = ((x - cx) * Math.cos(angle) - (y - cy) * Math.sin(angle))
        var x2 = this.reverse ? cx - translationX : cx + translationX
        var y2 = cy + (x - cx) * Math.sin(angle) + (y - cy) * Math.cos(angle);
        return [x2, y2]

    }
}


export class TreeLoadPlot {
    constructor(item, name = "") {
        this.x = [];
        this.y = [];
        this.id = item.id
        this.item = item;
        this.mode = 'lines+text+markers';
        this.type = 'scatter';
        this.name = this.hovertext = name + item.label
        this.line = {
            color: 'rgb(58,0,0)',
            width: 2,
        }
        this.hoverinfo = 'all'
        this.marker = {
            color: 'green',
            size: 5,

        }
    }
}

export class WindForcePlot {
    constructor(item, name = "") {
        this.x = [];
        this.y = [];
        this.id = item.id
        this.item = item;
        this.mode = 'lines+text+markers';
        this.type = 'scatter';
        this.name = this.hovertext = name + item.label
        this.line = {
            color: 'rgb(0,0,0)',
            width: 2,
        }
        this.hoverinfo = 'all'
        this.marker = {
            color: 'black',
            size: 3,
        }
    }
}